import { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch } from 'react-redux'
import { setNotification } from '../../../../Redux/Reducers/notificationHandling'

const formatApiMessage = (message) => {
  if (!message) return 'Failed'
  if (typeof message === 'string') return message
  if (typeof message === 'object') {
    return Object.values(message).flat().join(' ')
  }
  return 'Failed'
}

/** Active block Codes tab: mass move Automatic sequence for school year */
const MoveSequenceButton = ({ locationId, onDone }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [canChange, setCanChange] = useState(true)
  const [blockedMessage, setBlockedMessage] = useState(null)

  useEffect(() => {
    if (!locationId) return
    request('get-code-by-location-id', 'POST', { location_id: locationId, is_planned_block: false }).then((res) => {
      if (res?.status === 200) {
        setCanChange(res?.data?.can_change_sequence !== false)
        setBlockedMessage(res?.data?.mutation_blocked_message || null)
      }
    })
  }, [locationId])

  const openModal = () => {
    if (!canChange) {
      dispatch(
        setNotification({
          type: 'error',
          message: blockedMessage || 'Cannot change the code until the code issue date has passed, or after the year close date.',
        })
      )
      return
    }
    setOpen(true)
  }

  const run = (action) => {
    if (action === 'abort') {
      setOpen(false)
      return
    }
    setLoading(true)
    request('automatic-codes/move-sequence', 'POST', { location_id: locationId, action }).then((res) => {
      setLoading(false)
      setOpen(false)
      if (res?.status === 200) {
        dispatch(setNotification({ type: 'success', message: res?.data?.message || 'Sequence moved' }))
        onDone?.()
      } else {
        dispatch(setNotification({ type: 'error', message: formatApiMessage(res?.data?.message) }))
      }
    })
  }

  if (!locationId) return null

  return (
    <>
      <Button
        className='mr-2'
        title={!canChange ? blockedMessage || 'Code changes are blocked until issue date, or after year close' : undefined}
        style={{ background: primary_color, border: 'none', opacity: canChange ? 1 : 0.85 }}
        onClick={openModal}>
        Move sequence
      </Button>
      <Modal isOpen={open} toggle={() => !loading && setOpen(false)} centered style={{ boxShadow: 'none' }}>
        <ModalHeader toggle={() => !loading && setOpen(false)}>Move sequence</ModalHeader>
        <ModalBody>
          Are you sure you wish to move the sequence? This will change all Automatic codes at this school for this year. Please select an option:
          <div className='mt-3 d-flex flex-column' style={{ gap: '0.5rem' }}>
            <Button color='primary' disabled={loading} style={{ background: primary_color, border: 'none' }} onClick={() => run('change_no_email')}>
              Change all Codes at the School and DO NOT notify people that have already booked
            </Button>
            <Button color='warning' disabled={loading} onClick={() => run('change_reissue')}>
              Change all Codes at the School and resend confirmation emails
            </Button>
            <Button color='secondary' disabled={loading} onClick={() => run('abort')}>
              Abort
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default MoveSequenceButton
